<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">Manage AP-Check</div>
    </div>
    <div class="col-md-12 well-content">
        <form #frm="ngForm" class="form-horizontal">
            @if (APCheckInfo) {
                <div class="panel panel-default">
                    <div class="panel-heading">General</div>
                    <div class="panel-body">
                        <div class="form-group">
                            <div class="col-md-2 control-label">Options</div>
                            <div class="col-md-4 options-div">
                                <div>
                                    <nz-switch
                                        [nz-tooltip]="bankTip"
                                        name="usesBankAccount"
                                        id="usesBankAccount"
                                        nzSize="small"
                                        [(ngModel)]="APCheckInfo.UsesBankAccount"
                                        [nzCheckedChildren]="checkedTmpl"
                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                    <span
                                        class="has-tooltip"
                                        [nz-tooltip]="bankTip"
                                        (click)="APCheckInfo.UsesBankAccount = !APCheckInfo.UsesBankAccount"
                                        >Use Bank Account Number</span
                                    >
                                </div>
                                <div>
                                    <nz-switch
                                        [nz-tooltip]="canadaTip"
                                        name="isCanadian"
                                        id="isCanadian"
                                        nzSize="small"
                                        [(ngModel)]="APCheckInfo.IsCanadian"
                                        [nzCheckedChildren]="checkedTmpl"
                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                    <span
                                        class="has-tooltip"
                                        [nz-tooltip]="canadaTip"
                                        (click)="APCheckInfo.IsCanadian = !APCheckInfo.IsCanadian"
                                        >Always Apply Secondary Signature</span
                                    >
                                </div>
                                <div>
                                    <nz-switch
                                        [nz-tooltip]="checkOrderTip"
                                        name="printAscending"
                                        id="printAscending"
                                        nzSize="small"
                                        [(ngModel)]="APCheckInfo.CheckOrderAscending"
                                        [nzCheckedChildren]="checkedTmpl"
                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                    <span
                                        class="has-tooltip"
                                        [nz-tooltip]="checkOrderTip"
                                        (click)="APCheckInfo.CheckOrderAscending = !APCheckInfo.CheckOrderAscending"
                                        >Print Checks in Ascending Order</span
                                    >
                                </div>
                                <div>
                                    <nz-switch
                                        [nz-tooltip]="deleteStampedTip"
                                        name="deleteStamped"
                                        id="deleteStamped"
                                        nzSize="small"
                                        [(ngModel)]="APCheckInfo.DeleteStampedChecks"
                                        [nzCheckedChildren]="checkedTmpl"
                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                    <span
                                        class="has-tooltip"
                                        [nz-tooltip]="deleteStampedTip"
                                        (click)="APCheckInfo.DeleteStampedChecks = !APCheckInfo.DeleteStampedChecks"
                                        >Delete Stamped Checks</span
                                    >
                                </div>
                            </div>
                        </div>
                        @if (!APCheckInfo.IsCanadian) {
                            <div class="form-group">
                                <div class="col-md-2 control-label has-tooltip" [nz-tooltip]="dualSigTip">
                                    Dual Signature Threshold
                                </div>
                                <div class="col-md-4 options-div">
                                    <div>
                                        <nz-input-number
                                            name="dualSig"
                                            id="dualSig"
                                            required
                                            style="width: auto"
                                            [nzPrecision]="2"
                                            [nzControls]="false"
                                            nzPlaceHolder="0.00"
                                            [nzFormatter]="dollarFormatter"
                                            [nzParser]="dollarParser"
                                            [nzMin]="0"
                                            [nzMax]="99999999.99"
                                            [(ngModel)]="APCheckInfo.DualSignatureThreshold"></nz-input-number>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
            <div class="panel panel-default">
                <div class="panel-heading">Details</div>
                <div class="panel-body">
                    <nz-tabs nzType="card" style="margin-top: 16px">
                        <nz-tab id="docType-panel" [nzTitle]="docTypeSettings">
                            @if (APCheckInfo) {
                                <div class="panel-body">
                                    <div class="panel-heading">Step 1 - Select Document Type:</div>
                                    <div>&nbsp;</div>
                                    <div class="form-group">
                                        <div class="col-md-3 control-label">Document Type</div>
                                        <div class="col-md-4">
                                            <div>
                                                <nz-select
                                                    nzShowSearch
                                                    nzSelectOnTab
                                                    [nzShowArrow]="false"
                                                    name="documentType"
                                                    id="documentType"
                                                    #docTypeMdl="ngModel"
                                                    [(ngModel)]="SelectedDocumentTypeId"
                                                    style="width: 100%"
                                                    required
                                                    nzPlaceHolder="Click to select/search for a document type"
                                                    (ngModelChange)="onDocumentTypeSelected()">
                                                    @for (docType of DocumentTypes; track docType) {
                                                        <nz-option
                                                            [nzValue]="docType.Id"
                                                            [nzLabel]="docType.Name"></nz-option>
                                                    }
                                                </nz-select>
                                                @if (
                                                    !SelectedDocumentTypeId ||
                                                    (docTypeMdl.touched && docTypeMdl.invalid)
                                                ) {
                                                    <span class="text-danger"> * Required </span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="panel-heading">Step 2 - Choose Keyword Fields From Document Type:</div>
                                    <div>&nbsp;</div>
                                    @if (APCheckInfo.UsesBankAccount) {
                                        <div class="form-group">
                                            <div class="col-md-3 control-label">"Bank Account Number"</div>
                                            <div class="col-md-4">
                                                <div>
                                                    <nz-select
                                                        nzShowSearch
                                                        nzSelectOnTab
                                                        [nzShowArrow]="false"
                                                        name="bankAccount"
                                                        id="bankAccount"
                                                        #bankMdl="ngModel"
                                                        [(ngModel)]="SelectedBankAccountKeywordId"
                                                        (ngModelChange)="onBankAccountSelected()"
                                                        style="width: 100%"
                                                        required
                                                        nzPlaceHolder="Click to select/search for a keyword">
                                                        @for (keyword of DocumentTypeKeywords; track keyword) {
                                                            <nz-option
                                                                [nzValue]="keyword.Id"
                                                                [nzLabel]="keyword.Name"></nz-option>
                                                        }
                                                    </nz-select>
                                                    @if (
                                                        !SelectedBankAccountKeywordId ||
                                                        (bankMdl.touched && bankMdl.invalid)
                                                    ) {
                                                        <span class="text-danger"> * Required </span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div class="form-group">
                                        <div class="col-md-3 control-label">"Check Number"</div>
                                        <div class="col-md-4">
                                            <div>
                                                <nz-select
                                                    nzShowSearch
                                                    nzSelectOnTab
                                                    [nzShowArrow]="false"
                                                    name="checkNumber"
                                                    id="checkNumber"
                                                    #checkMdl="ngModel"
                                                    [(ngModel)]="SelectedCheckNumberKeywordId"
                                                    (ngModelChange)="onCheckNumberSelected()"
                                                    style="width: 100%"
                                                    required
                                                    nzPlaceHolder="Click to select/search for a keyword">
                                                    @for (keyword of DocumentTypeKeywords; track keyword) {
                                                        <nz-option
                                                            [nzValue]="keyword.Id"
                                                            [nzLabel]="keyword.Name"></nz-option>
                                                    }
                                                </nz-select>
                                                @if (
                                                    !SelectedCheckNumberKeywordId ||
                                                    (checkMdl.touched && checkMdl.invalid)
                                                ) {
                                                    <span class="text-danger"> * Required </span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-md-3 control-label">"Amount"</div>
                                        <div class="col-md-4">
                                            <div>
                                                <nz-select
                                                    nzShowSearch
                                                    nzSelectOnTab
                                                    [nzShowArrow]="false"
                                                    name="amount"
                                                    id="amount"
                                                    #amountMdl="ngModel"
                                                    [(ngModel)]="SelectedAmountKeywordId"
                                                    (ngModelChange)="onAmountSelected()"
                                                    style="width: 100%"
                                                    required
                                                    nzPlaceHolder="Click to select/search for a keyword">
                                                    @for (keyword of DocumentTypeKeywords; track keyword) {
                                                        <nz-option
                                                            [nzValue]="keyword.Id"
                                                            [nzLabel]="keyword.Name"></nz-option>
                                                    }
                                                </nz-select>
                                                @if (
                                                    !SelectedAmountKeywordId || (amountMdl.touched && amountMdl.invalid)
                                                ) {
                                                    <span class="text-danger"> * Required </span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </nz-tab>
                        <nz-tab id="sig-panel" [nzTitle]="sigSettings">
                            <div class="panel-body">
                                <blockquote>Changing these values will update the preview image</blockquote>
                                <div class="row">
                                    @if (APCheckInfo) {
                                        <div class="col-md-4">
                                            <div class="panel-heading">Primary Signature:</div>
                                            <div class="form-group">
                                                <div class="col-md-3 control-label">X</div>
                                                <nz-input-number
                                                    class="col-md-3"
                                                    name="sig1x"
                                                    id="sig1x"
                                                    required
                                                    nzPlaceHolder="0"
                                                    #sig1Xmdl="ngModel"
                                                    [nzMin]="1"
                                                    [nzMax]="5000"
                                                    [nzStep]="1"
                                                    (nzBlur)="draw()"
                                                    (ngModelChange)="draw()"
                                                    [(ngModel)]="APCheckInfo.PrimarySignatureInfo.X"></nz-input-number>
                                                @if (sig1Xmdl.touched && sig1Xmdl.invalid) {
                                                    <span class="text-danger"> * Required </span>
                                                }
                                            </div>
                                            <div class="form-group">
                                                <div class="col-md-3 control-label">Y</div>
                                                <nz-input-number
                                                    class="col-md-3"
                                                    name="sig1y"
                                                    id="sig1y"
                                                    required
                                                    nzPlaceHolder="0"
                                                    #sig1Ymdl="ngModel"
                                                    [nzMin]="1"
                                                    [nzMax]="5000"
                                                    [nzStep]="1"
                                                    (nzBlur)="draw()"
                                                    (ngModelChange)="draw()"
                                                    [(ngModel)]="APCheckInfo.PrimarySignatureInfo.Y"></nz-input-number>
                                                @if (sig1Ymdl.touched && sig1Ymdl.invalid) {
                                                    <span class="text-danger"> * Required </span>
                                                }
                                            </div>
                                            <div class="form-group">
                                                <div class="col-md-3 control-label">Height</div>
                                                <nz-input-number
                                                    class="col-md-3"
                                                    name="sig1h"
                                                    id="sig1h"
                                                    required
                                                    nzPlaceHolder="0"
                                                    #sig1Hmdl="ngModel"
                                                    [nzMin]="1"
                                                    [nzMax]="5000"
                                                    [nzStep]="1"
                                                    (nzBlur)="draw()"
                                                    (ngModelChange)="draw()"
                                                    [(ngModel)]="
                                                        APCheckInfo.PrimarySignatureInfo.Height
                                                    "></nz-input-number>
                                                @if (sig1Hmdl.touched && sig1Hmdl.invalid) {
                                                    <span class="text-danger"> * Required </span>
                                                }
                                            </div>
                                            <div class="form-group">
                                                <div class="col-md-3 control-label">Width</div>
                                                <nz-input-number
                                                    class="col-md-3"
                                                    name="sig1w"
                                                    id="sig1w"
                                                    required
                                                    nzPlaceHolder="0"
                                                    #sig1Wmdl="ngModel"
                                                    [nzMin]="1"
                                                    [nzMax]="5000"
                                                    [nzStep]="1"
                                                    (nzBlur)="draw()"
                                                    (ngModelChange)="draw()"
                                                    [(ngModel)]="
                                                        APCheckInfo.PrimarySignatureInfo.Width
                                                    "></nz-input-number>
                                                @if (sig1Wmdl.touched && sig1Wmdl.invalid) {
                                                    <span class="text-danger"> * Required </span>
                                                }
                                            </div>
                                        </div>
                                    }
                                    @if (APCheckInfo) {
                                        <div class="col-md-4">
                                            <div class="panel-heading">Secondary Signature:</div>
                                            <div class="form-group">
                                                <div class="col-md-3 control-label">X</div>
                                                <nz-input-number
                                                    class="col-md-3"
                                                    name="sig2x"
                                                    id="sig2x"
                                                    required
                                                    nzPlaceHolder="0"
                                                    #sig2Xmdl="ngModel"
                                                    [nzMin]="1"
                                                    [nzMax]="5000"
                                                    [nzStep]="1"
                                                    (nzBlur)="draw()"
                                                    (ngModelChange)="draw()"
                                                    [(ngModel)]="
                                                        APCheckInfo.SecondarySignatureInfo.X
                                                    "></nz-input-number>
                                                @if (sig2Xmdl.touched && sig2Xmdl.invalid) {
                                                    <span class="text-danger"> * Required </span>
                                                }
                                            </div>
                                            <div class="form-group">
                                                <div class="col-md-3 control-label">Y</div>
                                                <nz-input-number
                                                    class="col-md-3"
                                                    name="sig2y"
                                                    id="sig2y"
                                                    required
                                                    nzPlaceHolder="0"
                                                    #sig2Ymdl="ngModel"
                                                    [nzMin]="1"
                                                    [nzMax]="5000"
                                                    [nzStep]="1"
                                                    (nzBlur)="draw()"
                                                    (ngModelChange)="draw()"
                                                    [(ngModel)]="
                                                        APCheckInfo.SecondarySignatureInfo.Y
                                                    "></nz-input-number>
                                                @if (sig2Ymdl.touched && sig2Ymdl.invalid) {
                                                    <span class="text-danger"> * Required </span>
                                                }
                                            </div>
                                            <div class="form-group">
                                                <div class="col-md-3 control-label">Height</div>
                                                <nz-input-number
                                                    class="col-md-3"
                                                    name="sig2h"
                                                    id="sig2h"
                                                    required
                                                    nzPlaceHolder="0"
                                                    #sig2Hmdl="ngModel"
                                                    [nzMin]="1"
                                                    [nzMax]="5000"
                                                    [nzStep]="1"
                                                    (nzBlur)="draw()"
                                                    (ngModelChange)="draw()"
                                                    [(ngModel)]="
                                                        APCheckInfo.SecondarySignatureInfo.Height
                                                    "></nz-input-number>
                                                @if (sig2Hmdl.touched && sig2Hmdl.invalid) {
                                                    <span class="text-danger"> * Required </span>
                                                }
                                            </div>
                                            <div class="form-group">
                                                <div class="col-md-3 control-label">Width</div>
                                                <nz-input-number
                                                    class="col-md-3"
                                                    name="sig2w"
                                                    id="sig2w"
                                                    required
                                                    nzPlaceHolder="0"
                                                    #sig2Wmdl="ngModel"
                                                    [nzMin]="1"
                                                    [nzMax]="5000"
                                                    [nzStep]="1"
                                                    (nzBlur)="draw()"
                                                    (ngModelChange)="draw()"
                                                    [(ngModel)]="
                                                        APCheckInfo.SecondarySignatureInfo.Width
                                                    "></nz-input-number>
                                                @if (sig2Wmdl.touched && sig2Wmdl.invalid) {
                                                    <span class="text-danger"> * Required </span>
                                                }
                                            </div>
                                        </div>
                                    }
                                    <div class="col-md-4">
                                        <canvas
                                            #canvasEl
                                            width="332"
                                            height="429"
                                            style="cursor: pointer"
                                            nz-tooltip="Click to redraw"
                                            (click)="draw()"></canvas>
                                        <div style="display: block; width: 75%">
                                            <div>
                                                <span style="background-color: blue">&nbsp;&nbsp;&nbsp;</span>
                                                &rightarrow; Primary Signature
                                            </div>
                                            <div>
                                                <span style="background-color: red">&nbsp;&nbsp;&nbsp;</span>
                                                &rightarrow; Secondary Signature
                                            </div>
                                        </div>
                                        <div>&nbsp;</div>
                                        <div class="has-tooltip" [nz-tooltip]="uploadTip">How do I use this?</div>
                                        <div style="display: inline-flex">
                                            <nz-upload
                                                name="upload"
                                                id="upload"
                                                nzListType="text"
                                                nzAccept="image/*"
                                                [nzBeforeUpload]="onBeforeUpload">
                                                <button type="button" class="btn btn-default">
                                                    <nz-icon nzType="upload" />
                                                    Use custom background
                                                </button>
                                            </nz-upload>
                                            &nbsp;
                                            <button
                                                type="button"
                                                class="btn btn-default"
                                                [disabled]="!backgroundImage"
                                                (click)="clearImage()">
                                                Remove image
                                            </button>
                                        </div>
                                        @if (testUploadError) {
                                            <div>
                                                <span style="color: red">{{ testUploadError }}</span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </nz-tab>
                    </nz-tabs>
                </div>
            </div>
            <div style="margin-top: 20px">
                @if (APCheckInfo) {
                    <button type="button" class="btn btn-default" (click)="save(frm)">Save</button>
                }
                @if (APCheckInfo) {
                    <button
                        type="button"
                        class="btn btn-default"
                        nz-tooltip="Undo all changes since the last successful save"
                        (click)="reset()">
                        Reset
                    </button>
                }
                @if (!loading) {
                    <button type="button" class="btn btn-default" (click)="viewLogs()">
                        <nz-icon nzType="read" nzTheme="fill" /> View Logs
                    </button>
                }
            </div>
        </form>
    </div>
    <ng-template #checkedTmpl><nz-icon nzType="check" /></ng-template>
    <ng-template #uncheckedTmpl><nz-icon nzType="close" /></ng-template>
    <ng-template #docTypeSettings><span style="font-weight: bold">Document Options</span></ng-template>
    <ng-template #sigSettings><span style="font-weight: bold">Signature Properties</span></ng-template>
</div>
